import type { Transaction } from '@/modules/projects'
import { RemovedSection } from './RemovedSection'
import { TransactionRow } from './TransactionRow'

// The cycle's rows as they print, plus the collapsed list of the ones taken out. Every section in the
// workspace shows the same table; only the header above it differs.
export const LedgerTable = ({
  rows,
  emptyMessage,
  onEditAmount,
  onRemove,
  onRestore,
  onJump,
}: {
  rows: Transaction[]
  // Shown in place of the table when the cycle has no rows at all. Sections that always have rows
  // leave it out and render an empty table instead.
  emptyMessage?: string
  onEditAmount: (row: Transaction, next: number) => void
  onRemove: (row: Transaction) => void
  onRestore: (row: Transaction) => void
  onJump: (page: number | null, fileUrl: string) => void
}) => {
  const kept = rows.filter((row) => !row.discardedAt)
  const removed = rows.filter((row) => row.discardedAt)

  return (
    <>
      {emptyMessage && kept.length === 0 && removed.length === 0 ? (
        <p className="py-6 text-center text-xs text-muted-foreground">
          {emptyMessage}
        </p>
      ) : (
        <table className="mt-2 w-full text-xs">
          <thead>
            <tr className="text-muted-foreground">
              <th className="py-1 pr-3 text-left font-normal">Date</th>
              <th className="py-1 pr-3 text-left font-normal">Description</th>
              <th className="w-32 py-1 pl-3 text-right font-normal">Amount</th>
              <th className="w-8" />
            </tr>
          </thead>
          <tbody>
            {kept.map((row) => (
              <TransactionRow
                key={row.id}
                row={row}
                onEditAmount={(next) => onEditAmount(row, next)}
                onRemove={() => onRemove(row)}
                onJump={onJump}
              />
            ))}
          </tbody>
        </table>
      )}

      <RemovedSection rows={removed} onRestore={onRestore} />
    </>
  )
}
